import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface RatingPreviewProps {
  value: number;
  className?: string;
  classNameText?: string;
}

export default function RatingPreview (props: RatingPreviewProps) {
  const { value, className, classNameText } = props

  return (
    <div className={cn(styles.root, className)}>
      <ReactSVG src="/icons/star.svg" />
      <span className={cn(styles.text, classNameText)}>{value}</span>
    </div>
  )
}
